import { IKMeansParameters } from '../k-means-interfaces';
import { calculateKMeansIteration, getMapKey, getPointIndex } from '../domain/k-means-provider';
import { useKMeansStore } from '../dal/kmeans-store';
import { getPointString, round } from '../../cluster-provider';

interface IIterationParams {
    params: IKMeansParameters;
    index: number;
}

const Iteration = ({ params, index }: IIterationParams) => {

    const distance = useKMeansStore(store => store.distance);

    const {
        tableMap,
        calculations,
        groups,
        newCenters,
        newCentersCalculations,
        oldAndNewCentroidsTheSame,
    } = calculateKMeansIteration(params, distance);

    return (
        <>
            <div className="mb-4">
                <strong className="mb-2">Итерация { index }</strong>
                <div className="flex gap-4">
                    <table>
                        <thead>
                        <tr>
                            <td className="border p-4 bg-slate-100 border-slate-200">&nbsp;</td>
                            {
                                params.centroids.map((centroid, ci) => {
                                    return (
                                        <td
                                            className="border p-4 bg-slate-100 border-slate-200"
                                            key={ `centroid-${ ci }` }>
                                            { `${ params.centroidsPrefix }${ getPointIndex(params.centroids, centroid) + 1 }` }<br/>
                                            { getPointString(centroid) }
                                        </td>
                                    )
                                })
                            }
                        </tr>
                        </thead>
                        <tbody>
                        {
                            params.points.map((point, pi) => {
                                return (
                                    <tr key={ `point-${ pi }` }>
                                        <td className="border p-4 bg-slate-100 b-slate-200">
                                            { `${ params.pointsPrefix }${ getPointIndex(params.points, point) + 1 }` } &nbsp;
                                            { getPointString(point) }
                                        </td>

                                        {
                                            params.centroids.map((centroid, ci) => {

                                                const key = getMapKey(centroid, point);

                                                return (
                                                    <td
                                                        className="border p-4 bg-slate-100 border-slate-200"
                                                        key={ `p-c-${ pi }-${ ci }` }>
                                                        { round(tableMap.get(key)) }
                                                    </td>
                                                )
                                            })
                                        }
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>

                    <div className="flex flex-col mr-6">
                        <strong className="mb-2">Calculations:</strong>
                        {
                            calculations.map((calculations, i) => {
                                return (
                                    <div key={ `calc-${ i }` } className="border-b">
                                        { calculations }
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className="bg-slate-100 px-4 py-2 mr-6">
                        <strong className="mb-2">Result Groups:</strong>
                        {
                            [...groups.entries()].map(([centroidKey, points]) => (
                                <div key={ centroidKey } className="border-b mb-2">
                                    <h3 className="font-bold">{ centroidKey }</h3>
                                    {
                                        points.map((point, p) => {
                                            return (
                                                <div key={ p } >
                                                    { `${ params.pointsPrefix }${ getPointIndex(params.points, point) + 1 }` } &nbsp;
                                                    { getPointString(point) }
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            ))}
                    </div>

                    <div>
                        <strong className="mb-2">New Centers:</strong>
                        <div className="mb-4">
                            {
                                newCenters.map((newCenter, nc) => {
                                    return (
                                        <div key={ nc } >
                                            { getPointString(newCenter) }
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <strong className="mb-2">New Centers Calculations:</strong>

                        <div className="mb-4">
                            {
                                newCentersCalculations.map((newCenter, nc) => {
                                    return (
                                        <div key={ nc } >
                                            { newCenter }
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <strong className="mb-2">Are old and new centroids the same?</strong>

                        <div>
                            { oldAndNewCentroidsTheSame.toString() }
                        </div>
                    </div>
                </div>
            </div>

            {
                !oldAndNewCentroidsTheSame && index < 15 &&
                <Iteration
                    params={{
                        points: params.points,
                        centroids: newCenters,
                        centroidsPrefix: params.centroidsPrefix,
                        pointsPrefix: params.pointsPrefix,
                    }}
                    index={ index + 1 }
                />
            }
        </>
    )
};

export default Iteration;